import React, {useEffect, useState} from "react";
import {useParams} from "react-router-dom";
import {observer} from "mobx-react-lite";
import VillageCalendarsCreateEditTemplate from "../../../../components/templates/villageCalendars/villageCalendarsCreateEditTemplate";
import {useStores} from "../../../../stores/useStores";
import {
  VillageCalendarConfig,
  VillageCalendarConfigPayload
} from "../../../../shared/interfaces/villageCalendarConfig";

/* istanbul ignore file */
const EditVillageCalendar: React.FC = () => {
  const {id} = useParams<{id: string}>();
  const {
    domainStore: {villageCalendarsDomainStore}
  } = useStores();

  const [existing, setExisting] = useState<VillageCalendarConfig | undefined>(
    villageCalendarsDomainStore.getVillageCalendar(id)
  );

  useEffect(() => {
    const cached = villageCalendarsDomainStore.getVillageCalendar(id);
    if (cached) {
      setExisting(cached);
      return;
    }
    (async () => {
      await villageCalendarsDomainStore.getVillageCalendars();
      setExisting(villageCalendarsDomainStore.getVillageCalendar(id));
    })();
  }, [id, villageCalendarsDomainStore]);

  const onSave = async (payload: VillageCalendarConfigPayload) => {
    await villageCalendarsDomainStore.updateVillageCalendar(id, payload);
  };

  if (!existing) {
    return null;
  }

  return (
    <VillageCalendarsCreateEditTemplate existing={existing} onSave={onSave} />
  );
};

export default observer(EditVillageCalendar);
